import React from 'react';
import ReactCodeInput from 'react-code-input';
import 'sweetalert2/dist/sweetalert2.css';

import { baseStyles } from '../styles';
import { CodeFormProps } from '../types';
import { usePhoneVerification } from '../hooks/usePhoneVerification';
import AuthActionButton from './AuthActionButton';
import { AuthState } from '../AuthState';

const PhoneCodeForm: React.FC<CodeFormProps> = ({ onSubmit }) => {
  const {
    phone,
    isLoading,
    codeUpdated,
    handleSubmit,
    handleBackClick,
    codeValue,
  } = usePhoneVerification(onSubmit);

  const phoneDisplay = formatAuthPhone(
    phone || AuthState.cognitoUser?.challengeParam?.phone_number || '',
  );

  if (isLoading) {
    return (
      <div style={baseStyles.clientReg}>
        <h4>Please wait...</h4>
      </div>
    );
  }
  return (
    <form style={baseStyles.clientReg} onSubmit={handleSubmit}>
      <h3>Enter the 4-digit code</h3>
      <h3 style={{ marginBottom: '25px' }}>sent to {phoneDisplay}</h3>
      <ReactCodeInput
        name="phone-code"
        inputMode="numeric"
        fields={4}
        onChange={codeUpdated}
        value={codeValue}
      />
      <AuthActionButton onClick={handleBackClick} />
    </form>
  );
};

export function formatAuthPhone(p: string | null) {
  if (p && p.length === 12) {
    return `${p.substring(0, 3)} ### ### ${p.substring(9, 12)}`;
  }
  if (p && p.length === 10) {
    return `#### ### ${p.substring(7, 10)}`;
  } else {
    return p;
  }
}

export { PhoneCodeForm };
